import { Action, createReducer, on } from '@ngrx/store';
import {
  purchaserIsCreatedAction,
  removeRecentPurchaserAction
} from 'src/app/actions/purchaser';

export interface PurchaserState {
  purchasers: any[];
  recentPurchaser?: any | null;
}

export const initialState: PurchaserState = {
  purchasers: [],
  recentPurchaser: null
};

const _purchaserReducer = createReducer(
  initialState,
  on(purchaserIsCreatedAction, (state, { newPurchaser }) => ({
    ...state,
    purchasers: [...state.purchasers, newPurchaser],
    recentPurchaser: newPurchaser
  })),
  on(removeRecentPurchaserAction, state => ({
    ...state,
    recentPurchaser: null
  }))
);

export function purchaserReducer(
  state: PurchaserState | undefined,
  action: Action
) {
  return _purchaserReducer(state, action);
}
